export const DATE_FORMAT = "yyyy-MM-dd";
export const TIME_FORMAT = "HH:mm:ss";
export const DATE_TIME_FORMAT = DATE_FORMAT + " " + TIME_FORMAT;
